import { StyledButton } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledButtonGolden = styled(StyledButton)`
  border: none;
  background: linear-gradient(
    160deg,
    rgba(255, 222, 101, 1) 0%,
    rgba(231, 168, 46, 1) 50%,
    rgba(229, 160, 26, 1) 100%
  );
  background-size: 200% 100%;
  background-position: 0% 0%;

  transition:
    background-position 0.2s ease-in-out,
    background-color 0.2s ease-in-out,
    color 0.2s ease-in-out,
    text-decoration 0.2s ease-in-out;

  &:hover:not(:disabled) {
    background-position: 100% 0%;
    color: ${({ theme }) => theme.colors.black};
  }
`;
